// saga-genesis v0.1.0
// Copyright 2018 Brendan Asselstine, Chuck Bergeron
// https://github.com/MedCredits/saga-genesis#readme
"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    React__default = _interopDefault(React),
    PropTypes = _interopDefault(require("prop-types")),
    reactRedux = require("react-redux"),
    Web3 = _interopDefault(require("web3")),
    BN = _interopDefault(require("bn.js")),
    abi = _interopDefault(require("ethjs-abi")),
    reduxSaga = require("redux-saga");

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

var classCallCheck = _classCallCheck;

function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}

function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}

var createClass = _createClass;

function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var _typeof_1 = createCommonjsModule(function (e) {
  function t(e) {
    return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function r(n) {
    return "function" == typeof Symbol && "symbol" === t(Symbol.iterator) ? e.exports = r = function r(e) {
      return t(e);
    } : e.exports = r = function r(e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : t(e);
    }, r(n);
  }

  e.exports = r;
});

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(e, t) {
  return !t || "object" !== _typeof_1(t) && "function" != typeof t ? assertThisInitialized(e) : t;
}

var possibleConstructorReturn = _possibleConstructorReturn,
    getPrototypeOf = createCommonjsModule(function (e) {
  function t(r) {
    return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, t(r);
  }

  e.exports = t;
}),
    setPrototypeOf = createCommonjsModule(function (e) {
  function t(r, n) {
    return e.exports = t = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    }, t(r, n);
  }

  e.exports = t;
});

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && setPrototypeOf(e, t);
}

var inherits = _inherits,
    ContractRegistryProvider = function (e) {
  function t() {
    return classCallCheck(this, t), possibleConstructorReturn(this, getPrototypeOf(t).apply(this, arguments));
  }

  return inherits(t, e), createClass(t, [{
    key: "getChildContext",
    value: function value() {
      return {
        contractRegistry: this.props.contractRegistry
      };
    }
  }, {
    key: "render",
    value: function value() {
      return React__default.Children.only(this.props.children);
    }
  }]), t;
}(React__default.Component);

ContractRegistryProvider.propTypes = {
  contractRegistry: PropTypes.object.isRequired
}, ContractRegistryProvider.childContextTypes = {
  contractRegistry: PropTypes.object
};

var _extends_1 = createCommonjsModule(function (e) {
  function t() {
    return e.exports = t = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }, t.apply(this, arguments);
  }

  e.exports = t;
});

function withContractRegistry(e) {
  var t = function (t) {
    function r() {
      return classCallCheck(this, r), possibleConstructorReturn(this, getPrototypeOf(r).apply(this, arguments));
    }

    return inherits(r, t), createClass(r, [{
      key: "render",
      value: function value() {
        return React__default.createElement(e, _extends_1({}, this.props, {
          contractRegistry: this.context.contractRegistry
        }));
      }
    }]), r;
  }(React.Component);

  return t.contextTypes = {
    contractRegistry: PropTypes.object
  }, t;
}

function _defineProperty(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

var defineProperty = _defineProperty,
    lastSagaKey = 0,
    debug = require("debug")("withSaga");

function getDisplayName(e) {
  return e.displayName || e.name || "Component";
}

function withSaga(e) {
  return function (t) {
    return reactRedux.connect(function (e) {
      return {
        sagaGenesisReady: e.sagaGenesis.sagaGenesisInit.initialized
      };
    }, function (t, r) {
      return {
        dispatchPrepareSaga: function dispatchPrepareSaga(r, n) {
          t({
            type: "PREPARE_SAGA",
            saga: e,
            key: n,
            props: r
          });
        },
        dispatchRunSaga: function dispatchRunSaga(r, n, a) {
          t({
            type: "RUN_SAGA_".concat(n),
            saga: e,
            props: r,
            key: n,
            displayName: a
          });
        },
        dispatchEndSaga: function dispatchEndSaga(e) {
          t({
            type: "END_SAGA_".concat(e),
            key: e
          });
        }
      };
    })(function (e) {
      function r(e, n) {
        var a;
        return classCallCheck(this, r), a = possibleConstructorReturn(this, getPrototypeOf(r).call(this, e, n)), defineProperty(assertThisInitialized(assertThisInitialized(a)), "displayName", "WithSaga(".concat(getDisplayName(t), ")")), a.sagaKey = ++lastSagaKey, debug("constructor ".concat(a.sagaKey)), a;
      }

      return inherits(r, e), createClass(r, [{
        key: "componentDidMount",
        value: function value() {
          debug("componentDidMount ".concat(this.sagaKey)), this.props.sagaGenesisReady && this.prepareSaga(this.props);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          debug("componentWillReceiveProps ".concat(this.sagaKey)), e.sagaGenesisReady && this.props.sagaGenesisReady !== e.sagaGenesisReady && this.prepareSaga(e);
        }
      }, {
        key: "prepareSaga",
        value: function value(e) {
          debug("prepareSaga ".concat(this.sagaKey)), e.dispatchPrepareSaga(e, this.sagaKey);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          debug("dispatchEndSaga ".concat(this.sagaKey)), this.props.dispatchEndSaga(this.sagaKey);
        }
      }, {
        key: "componentDidUpdate",
        value: function value() {
          this.props.sagaGenesisReady && (debug("dispatchRunSaga ".concat(this.sagaKey)), this.props.dispatchRunSaga(this.props, this.sagaKey, this.displayName));
        }
      }, {
        key: "render",
        value: function value() {
          return React__default.createElement(t, _extends_1({}, this.props, {
            sagaKey: this.sagaKey
          }));
        }
      }]), r;
    }(React.PureComponent));
  };
}

var _web3$1,
    construct = createCommonjsModule(function (e) {
  function t(r, n, a) {
    return !function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }() ? e.exports = t = function t(e, _t, r) {
      var n = [null];
      n.push.apply(n, _t);
      var a = new (Function.bind.apply(e, n))();
      return r && setPrototypeOf(a, r.prototype), a;
    } : e.exports = t = Reflect.construct, t.apply(null, arguments);
  }

  e.exports = t;
}),
    _web3 = null;

function getWeb3OrNull() {
  return !_web3 && window && window.web3 && (_web3 = new Web3(window.web3.currentProvider)), _web3;
}

function getWeb3() {
  return _web3$1 || (_web3$1 = getWeb3OrNull()), _web3$1 || (_web3$1 = new Web3()), _web3$1;
}

function sha3() {
  var e,
      t,
      r = getWeb3();
  return r.utils ? (e = r.utils.sha3).call.apply(e, [null].concat(Array.prototype.slice.call(arguments))) : (t = r.sha3).call.apply(t, [null].concat(Array.prototype.slice.call(arguments)));
}

function hashCall() {
  return sha3("NotAHex" + Array.from(arguments).join("-"));
}

var Call = function () {
  function e(t, r) {
    classCallCheck(this, e), this.address = t, this.method = r;

    for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) {
      a[o - 2] = arguments[o];
    }

    this.args = a, this.hash = hashCall.apply(void 0, [t, r].concat(a));
  }

  return createClass(e, [{
    key: "toString",
    value: function value(e) {
      return "".concat(this.address, ": ").concat(this.method, "(").concat(this.args.map(function (e) {
        return e.toString();
      }).join(", "), ")");
    }
  }]), e;
}();

function createCall(e, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) {
    n[a - 2] = arguments[a];
  }

  return construct(Call, [e, t].concat(n));
}

var transactionIds = 0;

function nextId() {
  return transactionIds += 1;
}

function withSend(e) {
  return reactRedux.connect(function () {
    return {};
  }, function (e, t) {
    return {
      dispatchSend: function dispatchSend(t, r, n, a) {
        e({
          type: "SG_SEND_TRANSACTION",
          transactionId: t,
          call: r,
          address: n,
          options: a
        });
      }
    };
  })(function (t) {
    function r() {
      var e, t;
      classCallCheck(this, r);

      for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++) {
        a[o] = arguments[o];
      }

      return t = possibleConstructorReturn(this, (e = getPrototypeOf(r)).call.apply(e, [this].concat(a))), defineProperty(assertThisInitialized(assertThisInitialized(t)), "send", function (e, r) {
        for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) {
          a[o - 2] = arguments[o];
        }

        return function (n) {
          var o = createCall.apply(void 0, [e, r].concat(a)),
              c = nextId();
          return t.props.dispatchSend(c, o, e, n), c;
        };
      }), t;
    }

    return inherits(r, t), createClass(r, [{
      key: "render",
      value: function value() {
        return React__default.createElement(e, _extends_1({}, this.props, {
          send: this.send
        }));
      }
    }]), r;
  }(React.Component));
}

function addLogListener(e, t) {
  return {
    type: "ADD_LOG_LISTENER",
    address: e,
    fromBlock: t
  };
}

function removeLogListener(e) {
  return {
    type: "REMOVE_LOG_LISTENER",
    address: e
  };
}

function mapDispatchToProps(e) {
  return {
    dispatchAddLogListener: function dispatchAddLogListener(t, r) {
      e(addLogListener(t, r));
    },
    dispatchRemoveLogListener: function dispatchRemoveLogListener(t) {
      e(removeLogListener(t));
    }
  };
}

function isDefined(e) {
  return null != e;
}

var LogListener = reactRedux.connect(function () {
  return {};
}, mapDispatchToProps)(function (e) {
  function t() {
    return classCallCheck(this, t), possibleConstructorReturn(this, getPrototypeOf(t).apply(this, arguments));
  }

  return inherits(t, e), createClass(t, [{
    key: "componentDidMount",
    value: function value() {
      this.props.address && isDefined(this.props.fromBlock) && this.props.dispatchAddLogListener(this.props.address, this.props.fromBlock);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function value(e) {
      var t = this.props.address && isDefined(this.props.fromBlock),
          r = this.props.address !== e.address,
          n = !1;
      t && r && (this.props.dispatchRemoveLogListener(), n = !0);
      var a = e.address && isDefined(e.fromBlock);
      t && !n || !a || this.props.dispatchAddLogListener(e.address, e.fromBlock);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.props.dispatchRemoveLogListener(this.props.address);
    }
  }, {
    key: "render",
    value: function value() {
      return React__default.createElement(React__default.Fragment, null, this.props.children);
    }
  }]), t;
}(React.Component));

function contractByName(e, t) {
  var r = e.sagaGenesis.network.networkId;
  if (e.sagaGenesis && e.sagaGenesis.contracts && e.sagaGenesis.contracts.networks[r] && e.sagaGenesis.contracts.networks[r].nameAddress) return e.sagaGenesis.contracts.networks[r].nameAddress[t];
}

function contractKeyByAddress(e, t) {
  if (t) {
    t = t.toLowerCase();
    var r = e.sagaGenesis.network.networkId;
    return e.sagaGenesis && e.sagaGenesis.contracts && e.sagaGenesis.contracts.networks[r] ? e.sagaGenesis.contracts.networks[r].addressContractKey[t] : void 0;
  }
}

function cacheCallState(e, t, r) {
  t && !t.startsWith("0x") && (t = contractByName(e, t));

  for (var n = arguments.length, a = new Array(n > 3 ? n - 3 : 0), o = 3; o < n; o++) {
    a[o - 3] = arguments[o];
  }

  var c = hashCall.apply(null, [t, r].concat(a));
  return e.sagaGenesis.callCache[c] || {};
}

function cacheCallValue(e, t, r) {
  for (var n = arguments.length, a = new Array(n > 3 ? n - 3 : 0), o = 3; o < n; o++) {
    a[o - 3] = arguments[o];
  }

  var c = cacheCallState.apply(void 0, [e, t, r].concat(a));
  if (c) return c.response;
}

function cacheCallValueInt(e, t, r) {
  for (var n = arguments.length, a = new Array(n > 3 ? n - 3 : 0), o = 3; o < n; o++) {
    a[o - 3] = arguments[o];
  }

  var c = cacheCallState.apply(void 0, [e, t, r].concat(a)).response;
  return c && (c = parseInt(c, 10)), c;
}

function cacheCallValueBigNumber(e, t, r) {
  for (var n = arguments.length, a = new Array(n > 3 ? n - 3 : 0), o = 3; o < n; o++) {
    a[o - 3] = arguments[o];
  }

  var c = cacheCallState.apply(void 0, [e, t, r].concat(a)).response;
  if (c) var s = new BN(c);
  return s;
}

function abiFactory(e) {
  return function (t, r) {
    return new t.eth.Contract(e, r);
  };
}

LogListener.propTypes = {
  address: PropTypes.string,
  fromBlock: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(BN)])
};

var ABIHelper = function () {
  function e(t) {
    var r = this;
    classCallCheck(this, e), this._lookup = {}, this._topic0Lookup = {}, t.forEach(function (e) {
      if (r._lookup[e.name] = e, "event" === e.type) {
        var t = r.topic0(e);
        r._topic0Lookup[t] = e;
      }
    });
  }

  return createClass(e, [{
    key: "lookup",
    value: function value(e) {
      return this._lookup[e];
    }
  }, {
    key: "topic0",
    value: function value(e) {
      var t,
          r = (t = "string" == typeof e ? this._lookup[e] : e).inputs.map(function (e) {
        return e.type;
      });
      return sha3("".concat(t.name, "(").concat(r.join(","), ")"));
    }
  }, {
    key: "decodeLogParameters",
    value: function value(e) {
      var t = this._topic0Lookup[e.topics[0]];
      return abi.decodeEvent(t, e.data, e.topics);
    }
  }]), e;
}(),
    CallCountRegistry = function () {
  function e() {
    classCallCheck(this, e), this.contractCalls = {}, this.keyCalls = {};
  }

  return createClass(e, [{
    key: "count",
    value: function value(e) {
      var t = this._getContractCallState(e);

      return t ? t.count : 0;
    }
  }, {
    key: "register",
    value: function value(e, t) {
      this._increment(e), this._getKeyCalls(t).push(e);
    }
  }, {
    key: "deregister",
    value: function value(e) {
      var t = this.decrementCalls(this._getKeyCalls(e));
      return delete this.keyCalls[e], t;
    }
  }, {
    key: "decrementCalls",
    value: function value(e) {
      var t = this;
      return e.reduce(function (e, r) {
        return t._decrement(r) || e.push(r), e;
      }, []);
    }
  }, {
    key: "getContractCalls",
    value: function value(e) {
      if (!e) return {};
      e = e.toLowerCase();
      var t = this.contractCalls[e];
      return t || (t = {}, this.contractCalls[e] = t), t;
    }
  }, {
    key: "resetKeyCalls",
    value: function value(e) {
      var t = this._getKeyCalls(e);

      return this.keyCalls[e] = [], t;
    }
  }, {
    key: "_getKeyCalls",
    value: function value(e) {
      var t = this.keyCalls[e];
      return t || (t = [], this.keyCalls[e] = t), t;
    }
  }, {
    key: "_increment",
    value: function value(e) {
      var t = this._getContractCallState(e);

      return t ? t.count += 1 : (t = {
        count: 1,
        call: e
      }, this.getContractCalls(e.address)[e.hash] = t), t.count;
    }
  }, {
    key: "_decrement",
    value: function value(e) {
      var t = this._getContractCallState(e),
          r = 0;

      return t && (t.count -= 1, 0 === t.count ? delete this.getContractCalls(e.address)[e.hash] : r = t.count), r;
    }
  }, {
    key: "_getContractCallState",
    value: function value(e) {
      return this.getContractCalls(e.address)[e.hash];
    }
  }]), e;
}(),
    ContractRegistry = function () {
  function e(t) {
    classCallCheck(this, e), this.config = t, this.contractCache = {};
  }

  return createClass(e, [{
    key: "has",
    value: function value(e) {
      return e = this.cleanAddress(e), !!this.contractCache[e];
    }
  }, {
    key: "get",
    value: function value(e, t, r) {
      e = this.cleanAddress(e);
      var n = this.contractCache[e];

      if (!n) {
        if (!t) throw new Error("No contract found for address ".concat(e, ", you must pass a contractKey for it to be constructed"));
        if (!this.config.contractFactories[t]) throw new Error("You need to register the ".concat(t, " contract in your ContractRegistry options"));
        n = this.config.contractFactories[t](r, e), this.contractCache[e] = n;
      }

      return n;
    }
  }, {
    key: "cleanAddress",
    value: function value(e) {
      return e && (e = e.toLowerCase()), e;
    }
  }]), e;
}();

function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {},
        n = Object.keys(r);
    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    }))), n.forEach(function (t) {
      defineProperty(e, t, r[t]);
    });
  }

  return e;
}

var root,
    objectSpread = _objectSpread;

function logReducerFactory(e) {
  return function (t, r) {
    var n = r.type,
        a = r.logs,
        o = r.log;

    switch (void 0 === t && (t = {}), n) {
      case "PAST_LOGS":
        t = objectSpread({}, t), a.forEach(function (r) {
          e(t, r);
        });
        break;

      case "NEW_LOG":
        t = objectSpread({}, t), e(t, o);
    }

    return t;
  };
}

function symbolObservablePonyfill(e) {
  var t,
      r = e.Symbol;
  return "function" == typeof r ? r.observable ? t = r.observable : (t = r("observable"), r.observable = t) : t = "@@observable", t;
}

var result = symbolObservablePonyfill(root = "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof module ? module : Function("return this")()),
    randomString = function randomString() {
  return Math.random().toString(36).substring(7).split("").join(".");
},
    ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

function isPlainObject(e) {
  if ("object" != typeof e || null === e) return !1;

  for (var t = e; null !== Object.getPrototypeOf(t);) {
    t = Object.getPrototypeOf(t);
  }

  return Object.getPrototypeOf(e) === t;
}

function warning(e) {
  "undefined" != typeof console && "function" == typeof console.error && console.error(e);

  try {
    throw new Error(e);
  } catch (e) {}
}

function getUndefinedStateErrorMessage(e, t) {
  var r = t && t.type;
  return "Given " + (r && 'action "' + String(r) + '"' || "an action") + ', reducer "' + e + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(e, t, r, n) {
  var a = Object.keys(t),
      o = r && r.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (0 === a.length) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!isPlainObject(e)) return "The " + o + ' has unexpected type of "' + {}.toString.call(e).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following keys: "' + a.join('", "') + '"';
  var c = Object.keys(e).filter(function (e) {
    return !t.hasOwnProperty(e) && !n[e];
  });
  return c.forEach(function (e) {
    n[e] = !0;
  }), r && r.type === ActionTypes.REPLACE ? void 0 : c.length > 0 ? "Unexpected " + (c.length > 1 ? "keys" : "key") + ' "' + c.join('", "') + '" found in ' + o + '. Expected to find one of the known reducer keys instead: "' + a.join('", "') + '". Unexpected keys will be ignored.' : void 0;
}

function assertReducerShape(e) {
  Object.keys(e).forEach(function (t) {
    var r = e[t];
    if (void 0 === r(void 0, {
      type: ActionTypes.INIT
    })) throw new Error('Reducer "' + t + "\" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.");
    if (void 0 === r(void 0, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    })) throw new Error('Reducer "' + t + "\" returned undefined when probed with a random type. Don't try to handle " + ActionTypes.INIT + ' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.');
  });
}

function combineReducers(e) {
  for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
    var a = t[n];
    "production" !== process.env.NODE_ENV && void 0 === e[a] && warning('No reducer provided for key "' + a + '"'), "function" == typeof e[a] && (r[a] = e[a]);
  }

  var o,
      c,
      s = Object.keys(r);
  "production" !== process.env.NODE_ENV && (o = {});

  try {
    assertReducerShape(r);
  } catch (e) {
    c = e;
  }

  return function (e, t) {
    if (void 0 === e && (e = {}), c) throw c;

    if ("production" !== process.env.NODE_ENV) {
      var n = getUnexpectedStateShapeWarningMessage(e, r, t, o);
      n && warning(n);
    }

    for (var a = !1, i = {}, u = 0; u < s.length; u++) {
      var l = s[u],
          d = r[l],
          p = e[l],
          f = d(p, t);

      if (void 0 === f) {
        var h = getUndefinedStateErrorMessage(l, t);
        throw new Error(h);
      }

      i[l] = f, a = a || f !== p;
    }

    return a ? i : e;
  };
}

function isCrushed() {}

function accounts(e, t) {
  var r = t.type,
      n = t.accounts;

  switch (void 0 === e && (e = []), r) {
    case "WEB3_ACCOUNTS":
      e = n;
  }

  return e;
}

function contracts(e, t) {
  var r = t.type,
      n = t.address,
      a = t.name,
      o = t.contractKey,
      c = t.networkId;

  switch (void 0 === e && (e = {
    networks: {}
  }), r) {
    case "ADD_CONTRACT":
      var s = e.networks[c] || {};
      s = (e = {
        networks: objectSpread({}, e.networks, defineProperty({}, c, objectSpread({}, s, {
          addressContractKey: objectSpread({}, s.addressContractKey, defineProperty({}, n, o))
        })))
      }).networks[c] || {}, a && (e = {
        networks: objectSpread({}, e.networks, defineProperty({}, c, objectSpread({}, s, {
          nameAddress: objectSpread({}, s.nameAddress, defineProperty({}, a, n))
        })))
      });
  }

  return e;
}

function callCache(e, t) {
  var r = t.type,
      n = t.call,
      a = t.response,
      o = t.error,
      c = t.calls;

  switch (void 0 === e && (e = {}), r) {
    case "WEB3_STALE_CALLS":
      e = objectSpread({}, e), c.forEach(function (t) {
        e[t.hash].stale = !0;
      });
      break;

    case "WEB3_CALL":
      e = objectSpread({}, e, defineProperty({}, n.hash, objectSpread({}, e[n.hash], {
        inFlight: !0,
        stale: !1
      })));
      break;

    case "WEB3_CALL_RETURN":
      e = objectSpread({}, e, defineProperty({}, n.hash, objectSpread({}, e[n.hash], {
        inFlight: !1,
        response: a
      })));
      break;

    case "WEB3_CALL_ERROR":
      e = objectSpread({}, e, defineProperty({}, n.hash, objectSpread({}, e[n.hash], {
        inFlight: !1,
        error: o
      })));
      break;

    case "WEB3_CALL_CANCELLED":
      e = objectSpread({}, e, defineProperty({}, n.hash, objectSpread({}, e[n.hash], {
        inFlight: !1
      })));
  }

  return e;
}

function transactions(e, t) {
  var r = t.type,
      n = t.transactionId,
      a = t.call,
      o = t.options,
      c = t.error,
      s = t.receipt,
      i = t.gasUsed,
      u = t.txHash,
      l = t.confirmationNumber,
      d = t.address;

  switch (void 0 === e && (e = {}), r) {
    case "SG_START_TRANSACTION":
      e = objectSpread({}, e, defineProperty({}, n, {
        transactionId: n,
        call: a,
        options: o || {},
        address: d,
        inFlight: !0
      }));
      break;

    case "SG_TRANSACTION_HASH":
      e[n] && (e = objectSpread({}, e, defineProperty({}, n, objectSpread({}, e[n], {
        inFlight: !1,
        submitted: !0,
        txHash: u
      }))));
      break;

    case "SG_TRANSACTION_RECEIPT":
      e[n] && (e = objectSpread({}, e, defineProperty({}, n, objectSpread({}, e[n], {
        inFlight: !1,
        complete: !0,
        receipt: s
      }))));
      break;

    case "SG_TRANSACTION_CONFIRMED":
      e[n] && (e = objectSpread({}, e, defineProperty({}, n, objectSpread({}, e[n], {
        confirmed: !0,
        receipt: s
      }))));
      break;

    case "SG_TRANSACTION_CONFIRMATION":
      e[n] && (e = objectSpread({}, e, defineProperty({}, n, objectSpread({}, e[n], {
        confirmationNumber: l
      }))));
      break;

    case "SG_TRANSACTION_ERROR":
      e[n] && (e = objectSpread({}, e, defineProperty({}, n, objectSpread({}, e[n], {
        inFlight: !1,
        complete: !0,
        error: c,
        call: a,
        gasUsed: i
      }))));
      break;

    case "SG_CLEAR_TRANSACTIONS":
      e = {};
      break;

    case "SG_REMOVE_TRANSACTION":
      var p = Object.assign({}, e);
      delete p[n], e = p;
  }

  return e;
}

function ethBalance(e, t) {
  var r = t.type,
      n = t.balance;

  switch (void 0 === e && (e = {
    balance: void 0
  }), r) {
    case "ETH_BALANCE":
      e = {
        balance: n
      };
  }

  return e;
}

function network(e, t) {
  var r = t.type,
      n = t.networkId;

  switch (void 0 === e && (e = {
    networkId: void 0
  }), r) {
    case "WEB3_NETWORK_ID":
      e = {
        networkId: n
      };
  }

  return e;
}

function sagaGenesisInit(e, t) {
  var r = t.type,
      n = t.numConfirmationsRequired;

  switch (void 0 === e && (e = {
    initialized: !1,
    numConfirmationsRequired: 1
  }), r) {
    case "SG_UPDATE_SAGA_GENESIS_CONFIG":
      e = objectSpread({}, e, {
        numConfirmationsRequired: n
      });
      break;

    case "SG_SAGA_GENESIS_INITIALIZED":
      e = objectSpread({}, e, {
        initialized: !0
      });
  }

  return e;
}

function web3(e, t) {
  switch (void 0 === e && (e = {
    initialized: !1,
    error: !1
  }), t.type) {
    case "WEB3_INITIALIZED":
      e = objectSpread({}, e, {
        initialized: !0
      });
      break;

    case "WEB3_INITIALIZE_ERROR":
      e = objectSpread({}, e, {
        error: !0
      });
  }

  return e;
}

function logs(e, t) {
  var r = t.type,
      n = t.address,
      a = t.logs,
      o = t.log;

  switch (void 0 === e && (e = {}), r) {
    case "LOG_LISTENER_ADDED":
      e = e[n] ? objectSpread({}, e, defineProperty({}, n, objectSpread({}, e[n], {
        count: e[n].count + 1
      }))) : objectSpread({}, e, defineProperty({}, n, {
        count: 1
      }));
      break;

    case "PAST_LOGS":
      e = objectSpread({}, e, defineProperty({}, n, objectSpread({}, e[n], {
        logs: a
      })));
      break;

    case "NEW_LOG":
      (e = objectSpread({}, e))[n].logs.push(o);
      break;

    case "REMOVE_LOG_LISTENER":
      (e = objectSpread({}, e))[n] && (e[n].count -= 1, 0 === e[n].count && delete e[n]);
  }

  return e;
}

function block(e, t) {
  var r = t.type,
      n = t.block,
      a = t.blockNumber;

  switch (void 0 === e && (e = {
    latestBlock: {
      timestamp: Math.floor(Date.now() / 1e3)
    }
  }), r) {
    case "UPDATE_BLOCK_NUMBER":
      (e = objectSpread({}, e)).blockNumber = a;
      break;

    case "BLOCK_LATEST":
      (e = objectSpread({}, e)).latestBlock = n;
  }

  return e;
}

"production" !== process.env.NODE_ENV && "string" == typeof isCrushed.name && "isCrushed" !== isCrushed.name && warning('You are currently using minified code outside of NODE_ENV === "production". This means that you are running a slower development build of Redux. You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) to ensure you have the correct code for your production build.');

var reducers = combineReducers({
  callCache: callCache,
  accounts: accounts,
  transactions: transactions,
  network: network,
  ethBalance: ethBalance,
  contracts: contracts,
  web3: web3,
  logs: logs,
  block: block,
  sagaGenesisInit: sagaGenesisInit
}),
    runtime = createCommonjsModule(function (e) {
  !function (t) {
    var r,
        n = Object.prototype,
        a = n.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        c = o.iterator || "@@iterator",
        s = o.asyncIterator || "@@asyncIterator",
        i = o.toStringTag || "@@toStringTag",
        u = t.regeneratorRuntime;
    if (u) e.exports = u;else {
      (u = t.regeneratorRuntime = e.exports).wrap = b;
      var l = "suspendedStart",
          d = "suspendedYield",
          p = "executing",
          f = "completed",
          h = {},
          g = {};

      g[c] = function () {
        return this;
      };

      var y = Object.getPrototypeOf,
          k = y && y(y(N([])));
      k && k !== n && a.call(k, c) && (g = k);
      var v = C.prototype = x.prototype = Object.create(g);
      _.prototype = v.constructor = C, C.constructor = _, C[i] = _.displayName = "GeneratorFunction", u.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === _ || "GeneratorFunction" === (t.displayName || t.name));
      }, u.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, C) : (e.__proto__ = C, i in e || (e[i] = "GeneratorFunction")), e.prototype = Object.create(v), e;
      }, u.awrap = function (e) {
        return {
          __await: e
        };
      }, w(E.prototype), E.prototype[s] = function () {
        return this;
      }, u.AsyncIterator = E, u.async = function (e, t, r, n) {
        var a = new E(b(e, t, r, n));
        return u.isGeneratorFunction(t) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, w(v), v[i] = "Generator", v[c] = function () {
        return this;
      }, v.toString = function () {
        return "[object Generator]";
      }, u.keys = function (e) {
        var t = [];

        for (var r in e) {
          t.push(r);
        }

        return t.reverse(), function r() {
          for (; t.length;) {
            var n = t.pop();
            if (n in e) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, u.values = N, T.prototype = {
        constructor: T,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(R), !e) for (var t in this) {
            "t" === t.charAt(0) && a.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = r);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;

          function n(n, a) {
            return s.type = "throw", s.arg = e, t.next = n, a && (t.method = "next", t.arg = r), !!a;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var c = this.tryEntries[o],
                s = c.completion;
            if ("root" === c.tryLoc) return n("end");

            if (c.tryLoc <= this.prev) {
              var i = a.call(c, "catchLoc"),
                  u = a.call(c, "finallyLoc");

              if (i && u) {
                if (this.prev < c.catchLoc) return n(c.catchLoc, !0);
                if (this.prev < c.finallyLoc) return n(c.finallyLoc);
              } else if (i) {
                if (this.prev < c.catchLoc) return n(c.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < c.finallyLoc) return n(c.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var n = this.tryEntries[r];

            if (n.tryLoc <= this.prev && a.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
              var o = n;
              break;
            }
          }

          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var c = o ? o.completion : {};
          return c.type = e, c.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, h) : this.complete(c);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), h;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var a = n.arg;
                R(r);
              }

              return a;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: N(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = r), h;
        }
      };
    }

    function b(e, t, r, n) {
      var a = t && t.prototype instanceof x ? t : x,
          o = Object.create(a.prototype),
          c = new T(n || []);
      return o._invoke = function (e, t, r) {
        var n = l;
        return function (a, o) {
          if (n === p) throw new Error("Generator is already running");

          if (n === f) {
            if ("throw" === a) throw o;
            return L();
          }

          for (r.method = a, r.arg = o;;) {
            var c = r.delegate;

            if (c) {
              var s = A(c, r);

              if (s) {
                if (s === h) continue;
                return s;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (n === l) throw n = f, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = p;
            var i = m(e, t, r);

            if ("normal" === i.type) {
              if (n = r.done ? f : d, i.arg === h) continue;
              return {
                value: i.arg,
                done: r.done
              };
            }

            "throw" === i.type && (n = f, r.method = "throw", r.arg = i.arg);
          }
        };
      }(e, r, c), o;
    }

    function m(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    function x() {}

    function _() {}

    function C() {}

    function w(e) {
      ["next", "throw", "return"].forEach(function (t) {
        e[t] = function (e) {
          return this._invoke(t, e);
        };
      });
    }

    function E(e) {
      var t;

      this._invoke = function (r, n) {
        function o() {
          return new Promise(function (t, o) {
            !function t(r, n, o, c) {
              var s = m(e[r], e, n);

              if ("throw" !== s.type) {
                var i = s.arg,
                    u = i.value;
                return u && "object" == typeof u && a.call(u, "__await") ? Promise.resolve(u.__await).then(function (e) {
                  t("next", e, o, c);
                }, function (e) {
                  t("throw", e, o, c);
                }) : Promise.resolve(u).then(function (e) {
                  i.value = e, o(i);
                }, function (e) {
                  return t("throw", e, o, c);
                });
              }

              c(s.arg);
            }(r, n, t, o);
          });
        }

        return t = t ? t.then(o, o) : o();
      };
    }

    function A(e, t) {
      var n = e.iterator[t.method];

      if (n === r) {
        if (t.delegate = null, "throw" === t.method) {
          if (e.iterator.return && (t.method = "return", t.arg = r, A(e, t), "throw" === t.method)) return h;
          t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return h;
      }

      var a = m(n, e.iterator, t.arg);
      if ("throw" === a.type) return t.method = "throw", t.arg = a.arg, t.delegate = null, h;
      var o = a.arg;
      return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = r), t.delegate = null, h) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
    }

    function S(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function R(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function T(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(S, this), this.reset(!0);
    }

    function N(e) {
      if (e) {
        var t = e[c];
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var n = -1,
              o = function t() {
            for (; ++n < e.length;) {
              if (a.call(e, n)) return t.value = e[n], t.done = !1, t;
            }

            return t.value = r, t.done = !0, t;
          };

          return o.next = o;
        }
      }

      return {
        next: L
      };
    }

    function L() {
      return {
        value: r,
        done: !0
      };
    }
  }(function () {
    return this || "object" == typeof self && self;
  }() || Function("return this")());
}),
    g = function () {
  return this || "object" == typeof self && self;
}() || Function("return this")(),
    hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0,
    oldRuntime = hadRuntime && g.regeneratorRuntime;

g.regeneratorRuntime = void 0;
var runtimeModule = runtime;
if (hadRuntime) g.regeneratorRuntime = oldRuntime;else try {
  delete g.regeneratorRuntime;
} catch (e) {
  g.regeneratorRuntime = void 0;
}

var regenerator = runtimeModule,
    _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
},
    sym = function sym(e) {
  return "@@redux-saga/" + e;
},
    TASK = sym("TASK"),
    HELPER = sym("HELPER"),
    SELF_CANCELLATION = sym("SELF_CANCELLATION"),
    ident = function ident(e) {
  return e;
};

function check(e, t, r) {
  if (!t(e)) throw log("error", "uncaught at check", r), new Error(r);
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

function hasOwn(e, t) {
  return is.notUndef(e) && hasOwnProperty.call(e, t);
}

var is = {
  undef: function undef(e) {
    return null == e;
  },
  notUndef: function notUndef(e) {
    return null != e;
  },
  func: function func(e) {
    return "function" == typeof e;
  },
  number: function number(e) {
    return "number" == typeof e;
  },
  string: function string(e) {
    return "string" == typeof e;
  },
  array: Array.isArray,
  object: function object(e) {
    return e && !is.array(e) && "object" === (void 0 === e ? "undefined" : _typeof(e));
  },
  promise: function promise(e) {
    return e && is.func(e.then);
  },
  iterator: function iterator(e) {
    return e && is.func(e.next) && is.func(e.throw);
  },
  iterable: function iterable(e) {
    return e && is.func(Symbol) ? is.func(e[Symbol.iterator]) : is.array(e);
  },
  task: function task(e) {
    return e && e[TASK];
  },
  observable: function observable(e) {
    return e && is.func(e.subscribe);
  },
  buffer: function buffer(e) {
    return e && is.func(e.isEmpty) && is.func(e.take) && is.func(e.put);
  },
  pattern: function pattern(e) {
    return e && (is.string(e) || "symbol" === (void 0 === e ? "undefined" : _typeof(e)) || is.func(e) || is.array(e));
  },
  channel: function channel(e) {
    return e && is.func(e.take) && is.func(e.close);
  },
  helper: function helper(e) {
    return e && e[HELPER];
  },
  stringableFunc: function stringableFunc(e) {
    return is.func(e) && hasOwn(e, "toString");
  }
},
    kThrow = function kThrow(e) {
  throw e;
},
    kReturn = function kReturn(e) {
  return {
    value: e,
    done: !0
  };
};

function makeIterator(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : kThrow,
      r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
      n = arguments[3],
      a = {
    name: r,
    next: e,
    throw: t,
    return: kReturn
  };
  return n && (a[HELPER] = !0), "undefined" != typeof Symbol && (a[Symbol.iterator] = function () {
    return a;
  }), a;
}

function log(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
  "undefined" == typeof window ? console.log("redux-saga " + e + ": " + t + "\n" + (r && r.stack || r)) : console[e](t, r);
}

function deprecate(e, t) {
  return function () {
    return "development" === process.env.NODE_ENV && log("warn", t), e.apply(void 0, arguments);
  };
}

var updateIncentive = function updateIncentive(e, t) {
  return e + " has been deprecated in favor of " + t + ", please update your code";
},
    createSetContextWarning = function createSetContextWarning(e, t) {
  return (e ? e + "." : "") + "setContext(props): argument " + t + " is not a plain object";
},
    IO = sym("IO"),
    TAKE = "TAKE",
    PUT = "PUT",
    ALL = "ALL",
    RACE = "RACE",
    CALL = "CALL",
    CPS = "CPS",
    FORK = "FORK",
    JOIN = "JOIN",
    CANCEL$1 = "CANCEL",
    SELECT = "SELECT",
    ACTION_CHANNEL = "ACTION_CHANNEL",
    CANCELLED = "CANCELLED",
    FLUSH = "FLUSH",
    GET_CONTEXT = "GET_CONTEXT",
    SET_CONTEXT = "SET_CONTEXT",
    TEST_HINT = "\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)",
    effect = function effect(e, t) {
  var r;
  return (r = {})[IO] = !0, r[e] = t, r;
},
    detach = function detach(e) {
  return check(asEffect.fork(e), is.object, "detach(eff): argument must be a fork effect"), e[FORK].detached = !0, e;
};

function take() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "*";
  if (arguments.length && check(arguments[0], is.notUndef, "take(patternOrChannel): patternOrChannel is undefined"), is.pattern(e)) return effect(TAKE, {
    pattern: e
  });
  if (is.channel(e)) return effect(TAKE, {
    channel: e
  });
  throw new Error("take(patternOrChannel): argument " + String(e) + " is not valid channel or a valid pattern");
}

function put(e, t) {
  return arguments.length > 1 ? (check(e, is.notUndef, "put(channel, action): argument channel is undefined"), check(e, is.channel, "put(channel, action): argument " + e + " is not a valid channel"), check(t, is.notUndef, "put(channel, action): argument action is undefined")) : (check(e, is.notUndef, "put(action): argument action is undefined"), t = e, e = null), effect(PUT, {
    channel: e,
    action: t
  });
}

function all(e) {
  return effect(ALL, e);
}

function getFnCallDesc(e, t, r) {
  check(t, is.notUndef, e + ": argument fn is undefined");
  var n = null;

  if (is.array(t)) {
    var a = t;
    n = a[0], t = a[1];
  } else if (t.fn) {
    var o = t;
    n = o.context, t = o.fn;
  }

  return n && is.string(t) && is.func(n[t]) && (t = n[t]), check(t, is.func, e + ": argument " + t + " is not a function"), {
    context: n,
    fn: t,
    args: r
  };
}

function call(e) {
  for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  return effect(CALL, getFnCallDesc("call", e, r));
}

function fork(e) {
  for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  return effect(FORK, getFnCallDesc("fork", e, r));
}

function spawn(e) {
  for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  return detach(fork.apply(void 0, [e].concat(r)));
}

function cancel() {
  for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
    t[r] = arguments[r];
  }

  if (t.length > 1) return all(t.map(function (e) {
    return cancel(e);
  }));
  var n = t[0];
  return 1 === t.length && (check(n, is.notUndef, "cancel(task): argument task is undefined"), check(n, is.task, "cancel(task): argument " + n + " is not a valid Task object " + TEST_HINT)), effect(CANCEL$1, n || SELF_CANCELLATION);
}

function select(e) {
  for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  return 0 === arguments.length ? e = ident : (check(e, is.notUndef, "select(selector,[...]): argument selector is undefined"), check(e, is.func, "select(selector,[...]): argument " + e + " is not a function")), effect(SELECT, {
    selector: e,
    args: r
  });
}

function actionChannel(e, t) {
  return check(e, is.notUndef, "actionChannel(pattern,...): argument pattern is undefined"), arguments.length > 1 && (check(t, is.notUndef, "actionChannel(pattern, buffer): argument buffer is undefined"), check(t, is.buffer, "actionChannel(pattern, buffer): argument " + t + " is not a valid buffer")), effect(ACTION_CHANNEL, {
    pattern: e,
    buffer: t
  });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function getContext(e) {
  return check(e, is.string, "getContext(prop): argument " + e + " is not a string"), effect(GET_CONTEXT, e);
}

function setContext(e) {
  return check(e, is.object, createSetContextWarning(null, e)), effect(SET_CONTEXT, e);
}

take.maybe = function () {
  var e = take.apply(void 0, arguments);
  return e[TAKE].maybe = !0, e;
}, put.resolve = function () {
  var e = put.apply(void 0, arguments);
  return e[PUT].resolve = !0, e;
}, put.sync = deprecate(put.resolve, updateIncentive("put.sync", "put.resolve"));

var createAsEffectType = function createAsEffectType(e) {
  return function (t) {
    return t && t[IO] && t[e];
  };
},
    asEffect = {
  take: createAsEffectType(TAKE),
  put: createAsEffectType(PUT),
  all: createAsEffectType(ALL),
  race: createAsEffectType(RACE),
  call: createAsEffectType(CALL),
  cps: createAsEffectType(CPS),
  fork: createAsEffectType(FORK),
  join: createAsEffectType(JOIN),
  cancel: createAsEffectType(CANCEL$1),
  select: createAsEffectType(SELECT),
  actionChannel: createAsEffectType(ACTION_CHANNEL),
  cancelled: createAsEffectType(CANCELLED),
  flush: createAsEffectType(FLUSH),
  getContext: createAsEffectType(GET_CONTEXT),
  setContext: createAsEffectType(SET_CONTEXT)
},
    done = {
  done: !0,
  value: void 0
},
    qEnd = {};

function safeName(e) {
  return is.channel(e) ? "channel" : Array.isArray(e) ? String(e.map(function (e) {
    return String(e);
  })) : String(e);
}

function fsmIterator(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "iterator",
      n = void 0,
      a = t;

  function o(t, r) {
    if (a === qEnd) return done;
    if (r) throw a = qEnd, r;
    n && n(t);
    var o = e[a](),
        c = o[0],
        s = o[1],
        i = o[2];
    return n = i, (a = c) === qEnd ? done : s;
  }

  return makeIterator(o, function (e) {
    return o(null, e);
  }, r, !0);
}

var CHANNEL_END_TYPE = "@@redux-saga/CHANNEL_END",
    END = {
  type: CHANNEL_END_TYPE
};

function takeEvery(e, t) {
  for (var r = arguments.length, n = Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) {
    n[a - 2] = arguments[a];
  }

  var o = {
    done: !1,
    value: take(e)
  },
      c = void 0,
      s = function s(e) {
    return c = e;
  };

  return fsmIterator({
    q1: function q1() {
      return ["q2", o, s];
    },
    q2: function q2() {
      return c === END ? [qEnd] : ["q1", (e = c, {
        done: !1,
        value: fork.apply(void 0, [t].concat(n, [e]))
      })];
      var e;
    }
  }, "q1", "takeEvery(" + safeName(e) + ", " + t.name + ")");
}

function takeLatest(e, t) {
  for (var r = arguments.length, n = Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) {
    n[a - 2] = arguments[a];
  }

  var o = {
    done: !1,
    value: take(e)
  },
      c = function c(e) {
    return {
      done: !1,
      value: fork.apply(void 0, [t].concat(n, [e]))
    };
  },
      s = void 0,
      i = void 0,
      u = function u(e) {
    return s = e;
  },
      l = function l(e) {
    return i = e;
  };

  return fsmIterator({
    q1: function q1() {
      return ["q2", o, l];
    },
    q2: function q2() {
      return i === END ? [qEnd] : s ? ["q3", function (e) {
        return {
          done: !1,
          value: cancel(e)
        };
      }(s)] : ["q1", c(i), u];
    },
    q3: function q3() {
      return ["q1", c(i), u];
    }
  }, "q1", "takeLatest(" + safeName(e) + ", " + t.name + ")");
}

function takeEvery$2(e, t) {
  for (var r = arguments.length, n = Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) {
    n[a - 2] = arguments[a];
  }

  return fork.apply(void 0, [takeEvery, e, t].concat(n));
}

function takeLatest$2(e, t) {
  for (var r = arguments.length, n = Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) {
    n[a - 2] = arguments[a];
  }

  return fork.apply(void 0, [takeLatest, e, t].concat(n));
}

process.env.NODE_ENV;

var _marked = regenerator.mark(refreshAccounts),
    _marked2 = regenerator.mark(startAccountsPolling),
    _marked3 = regenerator.mark(_callee);

function refreshAccounts() {
  var e, t, r;
  return regenerator.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          return n.prev = 0, n.next = 3, getContext("web3");

        case 3:
          return e = n.sent, n.next = 6, select(function (e) {
            return e.sagaGenesis.accounts[0];
          });

        case 6:
          return t = n.sent, n.next = 9, e.eth.getAccounts();

        case 9:
          if ((r = n.sent)[0] === t) {
            n.next = 13;
            break;
          }

          return n.next = 13, put({
            type: "WEB3_ACCOUNTS",
            accounts: r
          });

        case 13:
          n.next = 19;
          break;

        case 15:
          return n.prev = 15, n.t0 = n.catch(0), n.next = 19, put({
            type: "SAGA_GENESIS_CAUGHT_ERROR",
            error: n.t0
          });

        case 19:
        case "end":
          return n.stop();
      }
    }
  }, _marked, this, [[0, 15]]);
}

function startAccountsPolling() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 3, call(refreshAccounts);

        case 3:
          return e.next = 5, call(reduxSaga.delay, 1e3);

        case 5:
          e.next = 0;
          break;

        case 7:
        case "end":
          return e.stop();
      }
    }
  }, _marked2, this);
}

function _callee() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 2, fork(startAccountsPolling);

        case 2:
        case "end":
          return e.stop();
      }
    }
  }, _marked3, this);
}

var _marked$1 = regenerator.mark(addContract);

function addContract(e) {
  var t, r, n, a;
  return regenerator.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          if (t = e.address, r = e.name, n = e.contractKey, a = e.networkId, t = t.toLowerCase(), a) {
            o.next = 7;
            break;
          }

          return o.next = 5, select(function (e) {
            return e.sagaGenesis.network.networkId;
          });

        case 5:
          (a = o.sent) || console.warn("No network ID available, cannot store ".concat(n, ": ").concat(t));

        case 7:
          return o.next = 9, select(contractKeyByAddress, t);

        case 9:
          if (o.sent === n) {
            o.next = 13;
            break;
          }

          return o.next = 13, put({
            type: "ADD_CONTRACT",
            address: t,
            name: r,
            contractKey: n,
            networkId: a
          });

        case 13:
        case "end":
          return o.stop();
      }
    }
  }, _marked$1, this);
}

var _marked$2 = regenerator.mark(takeSequentially);

function takeSequentially(e, t) {
  var r, n;
  return regenerator.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          return a.next = 2, actionChannel(e, reduxSaga.buffers.expanding(50));

        case 2:
          r = a.sent;

        case 3:
          return a.next = 6, take(r);

        case 6:
          return n = a.sent, a.next = 9, call(t, n);

        case 9:
          a.next = 3;
          break;

        case 11:
        case "end":
          return a.stop();
      }
    }
  }, _marked$2, this);
}

var _marked$3 = regenerator.mark(getReadWeb3),
    _marked2$1 = regenerator.mark(web3NetworkId),
    _marked3$1 = regenerator.mark(web3Initialize);

function getReadWeb3() {
  var e;
  return regenerator.wrap(function (t) {
    for (;;) {
      switch (t.prev = t.next) {
        case 0:
          return t.next = 2, getContext("readWeb3");

        case 2:
          if (e = t.sent) {
            t.next = 7;
            break;
          }

          return t.next = 6, getContext("web3");

        case 6:
          e = t.sent;

        case 7:
          return t.abrupt("return", e);

        case 8:
        case "end":
          return t.stop();
      }
    }
  }, _marked$3, this);
}

function web3NetworkId() {
  var e;
  return regenerator.wrap(function (t) {
    for (;;) {
      switch (t.prev = t.next) {
        case 0:
          return t.next = 2, getContext("web3");

        case 2:
          return e = t.sent, t.next = 5, e.eth.net.getId();

        case 5:
          return t.abrupt("return", t.sent);

        case 6:
        case "end":
          return t.stop();
      }
    }
  }, _marked2$1, this);
}

function web3Initialize() {
  var e;
  return regenerator.wrap(function (t) {
    for (;;) {
      switch (t.prev = t.next) {
        case 0:
          if (!(e = getWeb3OrNull())) {
            t.next = 16;
            break;
          }

          return t.prev = 2, t.next = 5, e.eth.net.getId();

        case 5:
          return t.next = 7, put({
            type: "WEB3_INITIALIZED",
            web3: e
          });

        case 7:
          t.next = 14;
          break;

        case 9:
          return t.prev = 9, t.t0 = t.catch(2), console.error("Could not get network, web3 in bad state!"), t.next = 14, put({
            type: "WEB3_INITIALIZE_ERROR"
          });

        case 14:
          t.next = 19;
          break;

        case 16:
          return console.error("window.web3 doesn't exist!"), t.next = 19, put({
            type: "WEB3_INITIALIZE_ERROR"
          });

        case 19:
        case "end":
          return t.stop();
      }
    }
  }, _marked3$1, this, [[2, 9]]);
}

var _marked$4 = regenerator.mark(getReceiptData),
    _marked2$2 = regenerator.mark(updateCurrentBlockNumber),
    _marked3$2 = regenerator.mark(gatherLatestBlocks),
    _marked4 = regenerator.mark(getBlockData),
    _marked5 = regenerator.mark(startBlockPolling),
    _marked6 = regenerator.mark(_callee$1),
    debug$1 = require("debug")("block-sagas"),
    MAX_RETRIES = 50;

function getReceiptData(e) {
  var t, r, n;
  return regenerator.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          return a.next = 2, getReadWeb3();

        case 2:
          t = a.sent, r = 0;

        case 4:
          if (!(r < MAX_RETRIES)) {
            a.next = 22;
            break;
          }

          return debug$1("getReceiptData web3.eth.getTransactionReceipt loop: ", e), a.next = 8, call(t.eth.getTransactionReceipt, e);

        case 8:
          if (!(n = a.sent)) {
            a.next = 13;
            break;
          }

          return a.abrupt("return", n);

        case 13:
          if (!(r > MAX_RETRIES)) {
            a.next = 17;
            break;
          }

          throw new Error("Unable to get receipt from network");

        case 17:
          return a.next = 19, call(reduxSaga.delay, 2e3);

        case 19:
          r++, a.next = 4;
          break;

        case 22:
        case "end":
          return a.stop();
      }
    }
  }, _marked$4, this);
}

function updateCurrentBlockNumber() {
  var e, t, r;
  return regenerator.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          return debug$1("updateCurrentBlockNumber()"), n.prev = 1, n.next = 4, getReadWeb3();

        case 4:
          return e = n.sent, n.next = 7, call(e.eth.getBlockNumber);

        case 7:
          return t = n.sent, n.next = 10, select(function (e) {
            return e.sagaGenesis.block.blockNumber;
          });

        case 10:
          if (r = n.sent, t === r) {
            n.next = 15;
            break;
          }

          return debug$1("updateCurrentBlockNumber got new block #"), n.next = 15, put({
            type: "UPDATE_BLOCK_NUMBER",
            blockNumber: t,
            lastBlockNumber: r
          });

        case 15:
          n.next = 22;
          break;

        case 17:
          return n.prev = 17, n.t0 = n.catch(1), console.warn("Warn in updateCurrentBlockNumber: " + n.t0), n.next = 22, put({
            type: "SAGA_GENESIS_CAUGHT_ERROR",
            error: n.t0
          });

        case 22:
        case "end":
          return n.stop();
      }
    }
  }, _marked2$2, this, [[1, 17]]);
}

function gatherLatestBlocks(e) {
  var t, r, n, a;
  return regenerator.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          if (t = e.blockNumber, r = e.lastBlockNumber, debug$1("gatherLatestBlocks(".concat(t, ", ").concat(r, ")")), r) {
            o.next = 4;
            break;
          }

          return o.abrupt("return");

        case 4:
          o.prev = 4, n = r + 1;

        case 6:
          if (!(n <= t)) {
            o.next = 16;
            break;
          }

          return o.next = 9, call(getBlockData, n);

        case 9:
          return a = o.sent, debug$1("BLOCK_LATEST"), o.next = 13, put({
            type: "BLOCK_LATEST",
            block: a
          });

        case 13:
          n++, o.next = 6;
          break;

        case 16:
          o.next = 23;
          break;

        case 18:
          return o.prev = 18, o.t0 = o.catch(4), console.warn("warn in getLatestBlocks()"), o.next = 23, put({
            type: "SAGA_GENESIS_CAUGHT_ERROR",
            error: o.t0
          });

        case 23:
        case "end":
          return o.stop();
      }
    }
  }, _marked3$2, this, [[4, 18]]);
}

function getBlockData(e) {
  var t, r, n;
  return regenerator.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          return debug$1("getBlockData() (".concat(e, ")")), a.next = 3, getReadWeb3();

        case 3:
          t = a.sent, r = 0;

        case 5:
          if (!(r < MAX_RETRIES)) {
            a.next = 23;
            break;
          }

          return debug$1("getBlockData() (attempt #".concat(r, ")")), a.next = 9, call(t.eth.getBlock, e, !0);

        case 9:
          if (!(n = a.sent)) {
            a.next = 14;
            break;
          }

          return a.abrupt("return", n);

        case 14:
          if (!(r > MAX_RETRIES)) {
            a.next = 18;
            break;
          }

          throw new Error("Unable to get block from network");

        case 18:
          return a.next = 20, call(reduxSaga.delay, 2e3);

        case 20:
          r++, a.next = 5;
          break;

        case 23:
        case "end":
          return a.stop();
      }
    }
  }, _marked4, this);
}

function startBlockPolling() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.prev = 1, e.next = 4, call(updateCurrentBlockNumber);

        case 4:
          e.next = 11;
          break;

        case 6:
          return e.prev = 6, e.t0 = e.catch(1), console.warn("warn in startBlockPolling()"), e.next = 11, put({
            type: "SAGA_GENESIS_CAUGHT_ERROR",
            error: e.t0
          });

        case 11:
          return e.next = 13, call(reduxSaga.delay, 1e3);

        case 13:
          e.next = 0;
          break;

        case 15:
        case "end":
          return e.stop();
      }
    }
  }, _marked5, this, [[1, 6]]);
}

function _callee$1() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 2, fork(takeSequentially, "UPDATE_BLOCK_NUMBER", gatherLatestBlocks);

        case 2:
          return e.next = 4, fork(startBlockPolling);

        case 4:
          debug$1("Started.");

        case 5:
        case "end":
          return e.stop();
      }
    }
  }, _marked6, this);
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = new Array(e.length); t < e.length; t++) {
      r[t] = e[t];
    }

    return r;
  }
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(e) {
  if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
}

var iterableToArray = _iterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(e) {
  return arrayWithoutHoles(e) || iterableToArray(e) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray,
    _marked$5 = regenerator.mark(waitForResponse),
    _marked2$3 = regenerator.mark(executeWeb3Call),
    _marked3$3 = regenerator.mark(registerCall),
    _marked4$1 = regenerator.mark(callCount),
    _marked5$1 = regenerator.mark(web3CallExecute),
    _marked6$1 = regenerator.mark(findWeb3Contract),
    _marked7 = regenerator.mark(findCallMethod),
    debug$2 = require("debug")("calls"),
    callsInFlight = new Set();

function isInFlight(e) {
  return callsInFlight.has(e.hash);
}

function waitForResponse(e) {
  var t;
  return regenerator.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          return r.next = 3, take(["WEB3_CALL_RETURN", "WEB3_CALL_ERROR"]);

        case 3:
          if ((t = r.sent).call.hash !== e.hash) {
            r.next = 10;
            break;
          }

          r.t0 = t.type, r.next = "WEB3_CALL_RETURN" === r.t0 ? 8 : 9;
          break;

        case 8:
          return r.abrupt("return", t.response);

        case 9:
          throw t.error;

        case 10:
          r.next = 0;
          break;

        case 12:
        case "end":
          return r.stop();
      }
    }
  }, _marked$5, this);
}

function executeWeb3Call(e) {
  return regenerator.wrap(function (t) {
    for (;;) {
      switch (t.prev = t.next) {
        case 0:
          if (isInFlight(e)) {
            t.next = 5;
            break;
          }

          return callsInFlight.add(e.hash), t.next = 5, put({
            type: "WEB3_CALL",
            call: e
          });

        case 5:
          return t.next = 7, waitForResponse(e);

        case 7:
          return t.abrupt("return", t.sent);

        case 8:
        case "end":
          return t.stop();
      }
    }
  }, _marked2$3, this);
}

function registerCall(e) {
  var t;
  return regenerator.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          return r.next = 2, getContext("key");

        case 2:
          if (t = r.sent) {
            r.next = 5;
            break;
          }

          throw new Error("registerCall called without a key scope: ".concat(JSON.stringify(e)));

        case 5:
          return r.next = 7, getContext("callCountRegistry");

        case 7:
          r.sent.register(e, t);

        case 9:
        case "end":
          return r.stop();
      }
    }
  }, _marked3$3, this);
}

function callCount(e) {
  var t;
  return regenerator.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          return r.next = 2, getContext("callCountRegistry");

        case 2:
          return t = r.sent, r.abrupt("return", t.count(e));

        case 4:
        case "end":
          return r.stop();
      }
    }
  }, _marked4$1, this);
}

function web3CallExecute(e) {
  var t, r, n, a;
  return regenerator.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          return t = e.call, debug$2("web3CallExecute", t), o.prev = 2, o.next = 5, select(function (e) {
            return e.sagaGenesis.accounts[0];
          });

        case 5:
          return r = o.sent, n = {
            from: r
          }, o.next = 9, findCallMethod(t);

        case 9:
          return a = o.sent, o.next = 12, spawn(regenerator.mark(function e() {
            var r;
            return regenerator.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.prev = 0, e.next = 3, call(a, n);

                  case 3:
                    return r = e.sent, e.next = 6, put({
                      type: "WEB3_CALL_RETURN",
                      call: t,
                      response: r
                    });

                  case 6:
                    e.next = 14;
                    break;

                  case 8:
                    return e.prev = 8, e.t0 = e.catch(0), debug$2("web3CallExecute rpc ERROR: ".concat(e.t0)), e.next = 13, put({
                      type: "WEB3_CALL_ERROR",
                      call: t,
                      error: e.t0
                    });

                  case 13:
                    console.error("Error on WEB3 Call: ", t.method, t.args, t, e.t0);

                  case 14:
                    return e.prev = 14, callsInFlight.delete(t.hash), e.finish(14);

                  case 17:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[0, 8, 14, 17]]);
          }));

        case 12:
          o.next = 28;
          break;

        case 14:
          return o.prev = 14, o.t0 = o.catch(2), debug$2("web3CallExecute general ERROR: ".concat(o.t0)), o.next = 19, cancelled();

        case 19:
          if (!o.sent) {
            o.next = 25;
            break;
          }

          return console.warn("Cancelled on WEB3 Call: ", t.method, t.args, t, o.t0), o.next = 23, put({
            type: "WEB3_CALL_CANCELLED",
            call: t
          });

        case 23:
          o.next = 28;
          break;

        case 25:
          return console.error("Error on WEB3 Call: ", t.method, t.args, t, o.t0), o.next = 28, put({
            type: "WEB3_CALL_ERROR",
            call: t,
            error: o.t0
          });

        case 28:
        case "end":
          return o.stop();
      }
    }
  }, _marked5$1, this, [[2, 14]]);
}

function findWeb3Contract(e) {
  var t, r, n;
  return regenerator.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          return a.next = 2, getContext("readContractRegistry");

        case 2:
          return t = a.sent, a.next = 5, getReadWeb3();

        case 5:
          return r = a.sent, a.next = 8, select(contractKeyByAddress, e);

        case 8:
          return n = a.sent, a.abrupt("return", t.get(e, n, r));

        case 10:
        case "end":
          return a.stop();
      }
    }
  }, _marked6$1, this);
}

function findCallMethod(e) {
  var t, r, n, a, o;
  return regenerator.wrap(function (c) {
    for (;;) {
      switch (c.prev = c.next) {
        case 0:
          return t = e.address, r = e.method, n = e.args, c.next = 3, findWeb3Contract(t);

        case 3:
          if (a = c.sent, o = a.methods[r]) {
            c.next = 9;
            break;
          }

          return c.next = 8, put({
            type: "WEB3_CALL_ERROR",
            call: e,
            error: "Address ".concat(t, " does not have method '").concat(r, "'")
          });

        case 8:
          return c.abrupt("return");

        case 9:
          return c.abrupt("return", o.apply(void 0, toConsumableArray(n)).call);

        case 10:
        case "end":
          return c.stop();
      }
    }
  }, _marked7, this);
}

var _marked$6 = regenerator.mark(addAddressIfExists);

function addAddressIfExists(e, t) {
  return regenerator.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          if (t) {
            r.next = 2;
            break;
          }

          return r.abrupt("return", !1);

        case 2:
          return t = t.toLowerCase(), r.next = 5, select(contractKeyByAddress, t);

        case 5:
          if (!r.sent) {
            r.next = 9;
            break;
          }

          return e.add(t), r.abrupt("return", !0);

        case 9:
          return r.abrupt("return", !1);

        case 10:
        case "end":
          return r.stop();
      }
    }
  }, _marked$6, this);
}

var _marked$7 = regenerator.mark(deregisterKey),
    _marked2$4 = regenerator.mark(invalidateAddress),
    _marked3$4 = regenerator.mark(invalidateTransaction),
    _marked4$2 = regenerator.mark(invalidateBlockAddresses),
    _marked5$2 = regenerator.mark(addTransactionReceiptAddresses),
    _marked6$2 = regenerator.mark(invalidateAddressSet),
    _marked7$1 = regenerator.mark(runSaga),
    _marked8 = regenerator.mark(prepareSaga),
    _marked9 = regenerator.mark(_callee6),
    debug$3 = require("debug")("cache-scope-sagas.js");

function deregisterKey(e) {
  var t, r;
  return regenerator.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          return n.next = 2, getContext("callCountRegistry");

        case 2:
          if (t = n.sent, !(r = t.deregister(e)).length) {
            n.next = 7;
            break;
          }

          return n.next = 7, put({
            type: "WEB3_STALE_CALLS",
            calls: r
          });

        case 7:
        case "end":
          return n.stop();
      }
    }
  }, _marked$7, this);
}

function invalidateAddress(e) {
  var t, r, n;
  return regenerator.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          return t = e.address, a.next = 3, getContext("callCountRegistry");

        case 3:
          if (r = a.sent, n = Object.values(r.getContractCalls(t))) {
            a.next = 7;
            break;
          }

          return a.abrupt("return");

        case 7:
          return a.next = 9, all(n.map(regenerator.mark(function e(t) {
            var r;
            return regenerator.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!(t.count > 0)) {
                      e.next = 4;
                      break;
                    }

                    return r = t.call, e.next = 4, executeWeb3Call(r);

                  case 4:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })));

        case 9:
        case "end":
          return a.stop();
      }
    }
  }, _marked2$4, this);
}

function invalidateTransaction(e) {
  var t, r, n;
  return regenerator.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          return e.transactionId, t = e.call, r = e.receipt, (n = Object.values(r.events || {}).reduce(function (e, t) {
            return e.add(t.address);
          }, new Set())).add(t.address), a.next = 5, all(Array.from(n).map(regenerator.mark(function e(t) {
            return regenerator.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, select(contractKeyByAddress, t);

                  case 2:
                    if (!e.sent) {
                      e.next = 6;
                      break;
                    }

                    return e.next = 6, fork(put, {
                      type: "CACHE_INVALIDATE_ADDRESS",
                      address: t
                    });

                  case 6:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })));

        case 5:
        case "end":
          return a.stop();
      }
    }
  }, _marked3$4, this);
}

function invalidateBlockAddresses(e) {
  var t, r, n, a, o, c, s;
  return regenerator.wrap(function (i) {
    for (;;) {
      switch (i.prev = i.next) {
        case 0:
          t = e.block, debug$3("invalidateBlockAddresses(): ", t), i.prev = 2, r = new Set(), i.t0 = regenerator.keys(t.transactions);

        case 5:
          if ((i.t1 = i.t0()).done) {
            i.next = 22;
            break;
          }

          return n = i.t1.value, a = t.transactions[n], i.next = 10, call(addAddressIfExists, r, a.to);

        case 10:
          return o = i.sent, i.next = 13, call(addAddressIfExists, r, a.from);

        case 13:
          if (c = i.sent, !o && !c) {
            i.next = 20;
            break;
          }

          return i.next = 17, call(getReceiptData, a.hash);

        case 17:
          return s = i.sent, i.next = 20, addTransactionReceiptAddresses(s, r);

        case 20:
          i.next = 5;
          break;

        case 22:
          return i.next = 24, invalidateAddressSet(r);

        case 24:
          i.next = 31;
          break;

        case 26:
          return i.prev = 26, i.t2 = i.catch(2), console.warn("warn in latestBlock()"), i.next = 31, put({
            type: "SAGA_GENESIS_CAUGHT_ERROR",
            error: i.t2
          });

        case 31:
        case "end":
          return i.stop();
      }
    }
  }, _marked4$2, this, [[2, 26]]);
}

function addTransactionReceiptAddresses(e, t) {
  return regenerator.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          return debug$3("addTransactionReceiptAddresses(): ".concat(e)), r.next = 3, all(e.logs.map(regenerator.mark(function e(r) {
            return regenerator.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, call(addAddressIfExists, t, r.address);

                  case 2:
                    if (!r.topics) {
                      e.next = 5;
                      break;
                    }

                    return e.next = 5, all(r.topics.map(regenerator.mark(function e(r) {
                      var n;
                      return regenerator.wrap(function (e) {
                        for (;;) {
                          switch (e.prev = e.next) {
                            case 0:
                              if (!r) {
                                e.next = 4;
                                break;
                              }

                              return n = "0x" + r.substr(26), e.next = 4, call(addAddressIfExists, t, n);

                            case 4:
                            case "end":
                              return e.stop();
                          }
                        }
                      }, e, this);
                    })));

                  case 5:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })));

        case 3:
        case "end":
          return r.stop();
      }
    }
  }, _marked5$2, this);
}

function invalidateAddressSet(e) {
  return regenerator.wrap(function (t) {
    for (;;) {
      switch (t.prev = t.next) {
        case 0:
          return t.next = 2, all(Array.from(e).map(regenerator.mark(function e(t) {
            return regenerator.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return debug$3("CACHE_INVALIDATE_ADDRESS ".concat(t)), e.next = 3, fork(put, {
                      type: "CACHE_INVALIDATE_ADDRESS",
                      address: t
                    });

                  case 3:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })));

        case 2:
        case "end":
          return t.stop();
      }
    }
  }, _marked6$2, this);
}

function runSaga(e) {
  var t, r, n, a, o, c;
  return regenerator.wrap(function (s) {
    for (;;) {
      switch (s.prev = s.next) {
        case 0:
          return t = e.saga, r = e.props, n = e.key, s.prev = 1, s.next = 4, setContext({
            key: n
          });

        case 4:
          return s.next = 6, getContext("callCountRegistry");

        case 6:
          return a = s.sent, o = a.resetKeyCalls(n), s.next = 10, call(t, r);

        case 10:
          if (!(c = a.decrementCalls(o)).length) {
            s.next = 14;
            break;
          }

          return s.next = 14, put({
            type: "WEB3_STALE_CALLS",
            calls: c
          });

        case 14:
          s.next = 26;
          break;

        case 16:
          return s.prev = 16, s.t0 = s.catch(1), s.next = 20, cancelled();

        case 20:
          if (s.sent) {
            s.next = 24;
            break;
          }

          throw s.t0;

        case 24:
          return s.next = 26, put({
            type: "SAGA_CANCELLED",
            key: n
          });

        case 26:
        case "end":
          return s.stop();
      }
    }
  }, _marked7$1, this, [[1, 16]]);
}

function prepareSaga(e) {
  var t, r, n, a, o;
  return regenerator.wrap(function (c) {
    for (;;) {
      switch (c.prev = c.next) {
        case 0:
          return t = e.saga, r = e.props, n = e.key, a = "RUN_SAGA_".concat(n), c.next = 4, takeLatest$2(a, runSaga);

        case 4:
          return o = c.sent, c.next = 7, runSaga({
            saga: t,
            props: r,
            key: n
          });

        case 7:
          return c.next = 9, take("END_SAGA_".concat(n));

        case 9:
          return c.next = 11, deregisterKey(n);

        case 11:
          return c.next = 13, cancel(o);

        case 13:
        case "end":
          return c.stop();
      }
    }
  }, _marked8, this);
}

function _callee6() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 2, takeEvery$2("PREPARE_SAGA", prepareSaga);

        case 2:
          return e.next = 4, fork(takeSequentially, "BLOCK_LATEST", invalidateBlockAddresses);

        case 4:
          return e.next = 6, takeEvery$2("CACHE_INVALIDATE_ADDRESS", invalidateAddress);

        case 6:
        case "end":
          return e.stop();
      }
    }
  }, _marked9, this);
}

var _marked$8 = regenerator.mark(isCacheActive),
    _marked2$5 = regenerator.mark(findResponse),
    _marked3$5 = regenerator.mark(runCall),
    _marked4$3 = regenerator.mark(cacheCall),
    _marked5$3 = regenerator.mark(cacheCallByName),
    _marked6$3 = regenerator.mark(cacheCallByAddress),
    _marked7$2 = regenerator.mark(callNoCache),
    _marked8$1 = regenerator.mark(web3Call),
    _marked9$1 = regenerator.mark(_callee$2),
    debug$4 = require("debug")("call-cache-sagas");

function isCacheActive(e) {
  var t;
  return regenerator.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          return r.next = 2, callCount(e);

        case 2:
          return t = r.sent, r.abrupt("return", t > 0);

        case 4:
        case "end":
          return r.stop();
      }
    }
  }, _marked$8, this);
}

function findResponse(e) {
  var t;
  return regenerator.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          return r.next = 2, select(function (t) {
            return t.sagaGenesis.callCache[e.hash];
          });

        case 2:
          return t = r.sent, r.abrupt("return", !t || t.response);

        case 4:
        case "end":
          return r.stop();
      }
    }
  }, _marked2$5, this);
}

function runCall(e, t) {
  var r, n;
  return regenerator.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          if (void 0 !== t) {
            a.next = 4;
            break;
          }

          return a.next = 3, isCacheActive(e);

        case 3:
          t = a.sent;

        case 4:
          if (r = null, n = isInFlight(e), !t || n) {
            a.next = 12;
            break;
          }

          return a.next = 9, findResponse(e);

        case 9:
          r = a.sent, a.next = 15;
          break;

        case 12:
          return a.next = 14, executeWeb3Call(e);

        case 14:
          r = a.sent;

        case 15:
          return a.abrupt("return", r);

        case 16:
        case "end":
          return a.stop();
      }
    }
  }, _marked3$5, this);
}

function cacheCall(e, t) {
  var r,
      n,
      a,
      o = arguments;
  return regenerator.wrap(function (c) {
    for (;;) {
      switch (c.prev = c.next) {
        case 0:
          for (r = o.length, n = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) {
            n[a - 2] = o[a];
          }

          if (!e.startsWith("0x")) {
            c.next = 7;
            break;
          }

          return c.next = 4, cacheCallByAddress.apply(void 0, [e, t].concat(n));

        case 4:
          return c.abrupt("return", c.sent);

        case 7:
          return c.next = 9, cacheCallByName.apply(void 0, [e, t].concat(n));

        case 9:
          return c.abrupt("return", c.sent);

        case 10:
        case "end":
          return c.stop();
      }
    }
  }, _marked4$3, this);
}

function cacheCallByName(e, t) {
  var r,
      n,
      a,
      o,
      c = arguments;
  return regenerator.wrap(function (s) {
    for (;;) {
      switch (s.prev = s.next) {
        case 0:
          return s.next = 2, select(contractByName, e);

        case 2:
          if (r = s.sent) {
            s.next = 5;
            break;
          }

          return s.abrupt("return", null);

        case 5:
          for (n = c.length, a = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) {
            a[o - 2] = c[o];
          }

          return s.next = 8, cacheCallByAddress.apply(void 0, [r, t].concat(a));

        case 8:
          return s.abrupt("return", s.sent);

        case 9:
        case "end":
          return s.stop();
      }
    }
  }, _marked5$3, this);
}

function cacheCallByAddress(e, t) {
  var r,
      n,
      a,
      o,
      c,
      s = arguments;
  return regenerator.wrap(function (i) {
    for (;;) {
      switch (i.prev = i.next) {
        case 0:
          for (r = s.length, n = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) {
            n[a - 2] = s[a];
          }

          return o = createCall.apply(void 0, [e, t].concat(n)), i.next = 4, isCacheActive(o);

        case 4:
          return c = i.sent, i.next = 7, registerCall(o);

        case 7:
          return i.next = 9, runCall(o, c);

        case 9:
          return i.abrupt("return", i.sent);

        case 10:
        case "end":
          return i.stop();
      }
    }
  }, _marked6$3, this);
}

function callNoCache(e, t) {
  var r,
      n,
      a,
      o,
      c = arguments;
  return regenerator.wrap(function (s) {
    for (;;) {
      switch (s.prev = s.next) {
        case 0:
          for (r = c.length, n = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) {
            n[a - 2] = c[a];
          }

          return o = createCall.apply(void 0, [e, t].concat(n)), s.next = 4, put({
            type: "WEB3_CALL",
            call: o
          });

        case 4:
          return s.next = 6, waitForResponse(o);

        case 6:
          return s.abrupt("return", s.sent);

        case 7:
        case "end":
          return s.stop();
      }
    }
  }, _marked7$2, this);
}

function web3Call(e, t) {
  var r,
      n,
      a,
      o,
      c = arguments;
  return regenerator.wrap(function (s) {
    for (;;) {
      switch (s.prev = s.next) {
        case 0:
          for (r = c.length, n = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) {
            n[a - 2] = c[a];
          }

          return o = createCall.apply(void 0, [e, t].concat(n)), s.next = 4, runCall(o);

        case 4:
          return s.abrupt("return", s.sent);

        case 5:
        case "end":
          return s.stop();
      }
    }
  }, _marked8$1, this);
}

function _callee$2() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 2, takeEvery$2("WEB3_CALL", web3CallExecute);

        case 2:
        case "end":
          return e.stop();
      }
    }
  }, _marked9$1, this);
}

var _marked$9 = regenerator.mark(refreshNetwork),
    _marked2$6 = regenerator.mark(startNetworkPolling),
    _marked3$6 = regenerator.mark(_callee$3);

function refreshNetwork() {
  var e, t, r;
  return regenerator.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          return n.next = 2, getContext("web3");

        case 2:
          return e = n.sent, n.next = 5, select(function (e) {
            return e.sagaGenesis.network.networkId;
          });

        case 5:
          return t = n.sent, n.prev = 6, n.next = 9, e.eth.net.getId();

        case 9:
          if (r = n.sent, t === r) {
            n.next = 13;
            break;
          }

          return n.next = 13, put({
            type: "WEB3_NETWORK_ID",
            web3: e,
            networkId: r
          });

        case 13:
          n.next = 19;
          break;

        case 15:
          return n.prev = 15, n.t0 = n.catch(6), n.next = 19, put({
            type: "SAGA_GENESIS_CAUGHT_ERROR",
            error: n.t0
          });

        case 19:
        case "end":
          return n.stop();
      }
    }
  }, _marked$9, this, [[6, 15]]);
}

function startNetworkPolling() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 3, call(refreshNetwork);

        case 3:
          return e.next = 5, call(reduxSaga.delay, 1e3);

        case 5:
          e.next = 0;
          break;

        case 7:
        case "end":
          return e.stop();
      }
    }
  }, _marked2$6, this);
}

function _callee$3() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 2, fork(startNetworkPolling);

        case 2:
        case "end":
          return e.stop();
      }
    }
  }, _marked3$6, this);
}

var _marked$a = regenerator.mark(getEthBalance),
    _marked2$7 = regenerator.mark(startEthBalancePolling),
    _marked3$7 = regenerator.mark(_callee$4);

function getEthBalance() {
  var e, t, r;
  return regenerator.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          return n.next = 2, getReadWeb3();

        case 2:
          return e = n.sent, n.next = 5, select(function (e) {
            return e.sagaGenesis.accounts[0];
          });

        case 5:
          if (t = n.sent, void 0 !== e && void 0 !== t) {
            n.next = 8;
            break;
          }

          return n.abrupt("return");

        case 8:
          return n.next = 10, call(e.eth.getBalance, t);

        case 10:
          return r = n.sent, n.next = 13, select(function (e) {
            return e.sagaGenesis.ethBalance.balance;
          });

        case 13:
          if (n.sent === r) {
            n.next = 17;
            break;
          }

          return n.next = 17, put({
            type: "ETH_BALANCE",
            balance: r
          });

        case 17:
        case "end":
          return n.stop();
      }
    }
  }, _marked$a, this);
}

function startEthBalancePolling() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.prev = 1, e.next = 4, call(getEthBalance);

        case 4:
          e.next = 11;
          break;

        case 6:
          return e.prev = 6, e.t0 = e.catch(1), console.warn("warn in startEthBalancePolling()", e.t0), e.next = 11, put({
            type: "SAGA_GENESIS_CAUGHT_ERROR",
            error: e.t0
          });

        case 11:
          return e.next = 13, call(reduxSaga.delay, 2e3);

        case 13:
          e.next = 0;
          break;

        case 15:
        case "end":
          return e.stop();
      }
    }
  }, _marked2$7, this, [[1, 6]]);
}

function _callee$4() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 2, fork(startEthBalancePolling);

        case 2:
        case "end":
          return e.stop();
      }
    }
  }, _marked3$7, this);
}

var _marked$b = regenerator.mark(web3Send),
    _marked2$8 = regenerator.mark(checkExternalTransactionReceipts),
    _marked3$8 = regenerator.mark(pollTransactions),
    _marked4$4 = regenerator.mark(_callee$5),
    debug$5 = require("debug")("transaction-sagas");

function createTransactionEventChannel(e, t, r, n, a) {
  return debug$5("#".concat(r, ": createTransactionEventChannel"), t), reduxSaga.eventChannel(function (e) {
    var o = n(a).on("transactionHash", function (n) {
      debug$5("#".concat(r, ": transactionHash ").concat(n)), e({
        type: "SG_TRANSACTION_HASH",
        transactionId: r,
        txHash: n,
        call: t
      });
    }).on("confirmation", function (n, o) {
      debug$5("#".concat(r, ": confirmation ").concat(n)), e({
        type: "SG_TRANSACTION_CONFIRMATION",
        transactionId: r,
        confirmationNumber: n,
        receipt: o
      }), n === a.numConfirmationsRequired && (e({
        type: "SG_TRANSACTION_CONFIRMED",
        transactionId: r,
        call: t,
        confirmationNumber: n,
        receipt: o
      }), e(reduxSaga.END));
    }).on("receipt", function (t) {
      debug$5("#".concat(r, ": receipt"), t), e({
        type: "SG_TRANSACTION_RECEIPT",
        transactionId: r,
        receipt: t
      });
    }).on("error", function (n) {
      debug$5("#".concat(r, ": error ").concat(n));
      var a = {
        type: "SG_TRANSACTION_ERROR",
        transactionId: r,
        call: t,
        error: n.toString()
      },
          o = n.message.match(/"gasUsed": ([0-9]*)/);
      o && (a.gasUsed = o[1]), e(a), e(reduxSaga.END);
    });
    return function () {
      o.removeAllListeners();
    };
  });
}

function web3Send(e) {
  var t, r, n, a, o, c, s, i, u, l, d, p, f, h, g;
  return regenerator.wrap(function (y) {
    for (;;) {
      switch (y.prev = y.next) {
        case 0:
          return t = e.transactionId, r = e.call, n = e.options, debug$5("#".concat(t, ": web3Send"), r), a = r.address, o = r.method, c = r.args, y.prev = 3, y.next = 6, put({
            type: "SG_START_TRANSACTION",
            transactionId: t,
            call: r,
            options: n,
            address: a
          });

        case 6:
          return y.next = 8, select(function (e) {
            return e.sagaGenesis.accounts[0];
          });

        case 8:
          return s = y.sent, n = Object.assign({
            from: s
          }, n || {}), y.next = 12, select(function (e) {
            return e.sagaGenesis.sagaGenesisInit.numConfirmationsRequired;
          });

        case 12:
          return n.numConfirmationsRequired = y.sent, y.next = 15, getContext("writeContractRegistry");

        case 15:
          return i = y.sent, y.next = 18, getContext("web3");

        case 18:
          return u = y.sent, y.next = 21, select(contractKeyByAddress, a);

        case 21:
          if (l = y.sent, d = i.get(a, l, u), p = d.methods[o]) {
            y.next = 28;
            break;
          }

          return y.next = 27, put({
            type: "SG_TRANSACTION_ERROR",
            transactionId: t,
            call: r,
            error: "Address ".concat(a, " does not have method '").concat(o, "'")
          });

        case 27:
          return y.abrupt("return");

        case 28:
          f = p.apply(void 0, toConsumableArray(c)), h = f.send, g = createTransactionEventChannel(u, r, t, h, n), y.prev = 31;

        case 32:
          return y.t0 = put, y.next = 36, take(g);

        case 36:
          return y.t1 = y.sent, y.next = 39, (0, y.t0)(y.t1);

        case 39:
          y.next = 32;
          break;

        case 41:
          return y.prev = 41, g.close(), y.finish(41);

        case 44:
          y.next = 51;
          break;

        case 46:
          return y.prev = 46, y.t2 = y.catch(3), debug$5("#".concat(t, " web3Send: ERROR"), r), y.next = 51, put({
            type: "SG_TRANSACTION_ERROR",
            transactionId: t,
            call: r,
            error: y.t2.message
          });

        case 51:
        case "end":
          return y.stop();
      }
    }
  }, _marked$b, this, [[3, 46], [31,, 41, 44]]);
}

function checkExternalTransactionReceipts(e) {
  var t, r, n, a, o, c, s, i, u, l;
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.prev = 0, e.next = 3, web3NetworkId();

        case 3:
          return e.sent, e.next = 6, getReadWeb3();

        case 6:
          return t = e.sent, e.next = 9, select(function (e) {
            return Object.values(e.sagaGenesis.transactions);
          });

        case 9:
          r = e.sent, n = 0;

        case 11:
          if (!(n < r.length)) {
            e.next = 32;
            break;
          }

          if (a = r[n], o = a.transactionId, c = a.txHash, a.txType, a.inFlight, s = a.call, i = a.submitted, u = a.complete, !i || u) {
            e.next = 29;
            break;
          }

          return e.next = 16, call(t.eth.getTransactionReceipt, c);

        case 16:
          if (!(l = e.sent)) {
            e.next = 29;
            break;
          }

          return e.next = 20, put({
            type: "SG_TRANSACTION_RECEIPT",
            transactionId: o,
            receipt: l,
            call: s
          });

        case 20:
          if (!l.status) {
            e.next = 25;
            break;
          }

          return e.next = 23, put({
            type: "SG_TRANSACTION_CONFIRMED",
            transactionId: o,
            receipt: l,
            call: s
          });

        case 23:
          e.next = 27;
          break;

        case 25:
          return e.next = 27, put({
            type: "SG_TRANSACTION_ERROR",
            transactionId: o,
            call: s,
            error: ""
          });

        case 27:
          e.next = 29;
          break;

        case 29:
          n++, e.next = 11;
          break;

        case 32:
          e.next = 37;
          break;

        case 34:
          e.prev = 34, e.t0 = e.catch(0), console.warn(e.t0);

        case 37:
        case "end":
          return e.stop();
      }
    }
  }, _marked2$8, this, [[0, 34]]);
}

function pollTransactions() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 3, call(checkExternalTransactionReceipts);

        case 3:
          return e.next = 5, call(reduxSaga.delay, 2e3);

        case 5:
          e.next = 0;
          break;

        case 7:
        case "end":
          return e.stop();
      }
    }
  }, _marked3$8, this);
}

function _callee$5() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 2, fork(pollTransactions);

        case 2:
          return e.next = 4, takeEvery$2("SG_SEND_TRANSACTION", web3Send);

        case 4:
        case "end":
          return e.stop();
      }
    }
  }, _marked4$4, this);
}

var _marked$c = regenerator.mark(sagaGenesisInit$1);

function sagaGenesisInit$1() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 2, put({
            type: "SG_SAGA_GENESIS_INITIALIZED"
          });

        case 2:
        case "end":
          return e.stop();
      }
    }
  }, _marked$c, this);
}

var _marked$d = regenerator.mark(addSubscription),
    _marked2$9 = regenerator.mark(checkLatestBlockForEvents),
    _marked3$9 = regenerator.mark(checkReceiptForEvents),
    _marked4$5 = regenerator.mark(logSaga),
    debug$6 = require("debug")("logSaga.js"),
    MAX_RETRIES$1 = 50,
    RETRY_DELAY = 2e3;

function addSubscription(e) {
  var t, r, n, a, o, c;
  return regenerator.wrap(function (s) {
    for (;;) {
      switch (s.prev = s.next) {
        case 0:
          return t = e.address, r = e.fromBlock, t = t.toLowerCase(), s.next = 4, put({
            type: "LOG_LISTENER_ADDED",
            address: t
          });

        case 4:
          return s.next = 6, select(function (e) {
            return e.sagaGenesis.logs[t];
          });

        case 6:
          if (1 !== s.sent.count) {
            s.next = 32;
            break;
          }

          return s.next = 10, getReadWeb3();

        case 10:
          n = s.sent, a = n.utils.toHex(r || 0), o = 0;

        case 13:
          if (!(o < MAX_RETRIES$1)) {
            s.next = 32;
            break;
          }

          return s.next = 16, call([n.eth, "getPastLogs"], {
            fromBlock: a,
            toBlock: "latest",
            address: t
          });

        case 16:
          if (!(c = s.sent)) {
            s.next = 23;
            break;
          }

          return s.next = 20, put({
            type: "PAST_LOGS",
            address: t,
            logs: c
          });

        case 20:
          return s.abrupt("return");

        case 23:
          if (!(o > MAX_RETRIES$1)) {
            s.next = 27;
            break;
          }

          throw new Error("Unable to get pastLogs from network");

        case 27:
          return s.next = 29, call(reduxSaga.delay, RETRY_DELAY);

        case 29:
          o++, s.next = 13;
          break;

        case 32:
        case "end":
          return s.stop();
      }
    }
  }, _marked$d, this);
}

function checkLatestBlockForEvents(e) {
  var t, r, n, a, o, c, s;
  return regenerator.wrap(function (i) {
    for (;;) {
      switch (i.prev = i.next) {
        case 0:
          t = e.block, debug$6("checkLatestBlockForEvents(): ", t), i.prev = 2, r = new Set(), i.t0 = regenerator.keys(t.transactions);

        case 5:
          if ((i.t1 = i.t0()).done) {
            i.next = 22;
            break;
          }

          return n = i.t1.value, a = t.transactions[n], i.next = 10, call(addAddressIfExists, r, a.to);

        case 10:
          return o = i.sent, i.next = 13, call(addAddressIfExists, r, a.from);

        case 13:
          if (c = i.sent, !o && !c) {
            i.next = 20;
            break;
          }

          return i.next = 17, call(getReceiptData, a.hash);

        case 17:
          return s = i.sent, i.next = 20, checkReceiptForEvents(s);

        case 20:
          i.next = 5;
          break;

        case 22:
          i.next = 29;
          break;

        case 24:
          return i.prev = 24, i.t2 = i.catch(2), console.warn("warn in latestBlock()"), i.next = 29, put({
            type: "SAGA_GENESIS_CAUGHT_ERROR",
            error: i.t2
          });

        case 29:
        case "end":
          return i.stop();
      }
    }
  }, _marked2$9, this, [[2, 24]]);
}

function checkReceiptForEvents(e) {
  return regenerator.wrap(function (t) {
    for (;;) {
      switch (t.prev = t.next) {
        case 0:
          return t.next = 2, all(e.logs.map(regenerator.mark(function e(t) {
            var r;
            return regenerator.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return r = t.address.toLowerCase(), e.next = 3, select(function (e) {
                      return e.sagaGenesis.logs[r];
                    });

                  case 3:
                    if (!e.sent) {
                      e.next = 7;
                      break;
                    }

                    return e.next = 7, put({
                      type: "NEW_LOG",
                      address: r,
                      log: t
                    });

                  case 7:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })));

        case 2:
        case "end":
          return t.stop();
      }
    }
  }, _marked3$9, this);
}

function logSaga() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 2, fork(takeSequentially, "ADD_LOG_LISTENER", addSubscription);

        case 2:
          return e.next = 4, fork(takeSequentially, "BLOCK_LATEST", checkLatestBlockForEvents);

        case 4:
        case "end":
          return e.stop();
      }
    }
  }, _marked4$5, this);
}

var _marked$e = regenerator.mark(takeOnceAndRun);

function takeOnceAndRun(e, t) {
  var r;
  return regenerator.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          return n.next = 2, take(e);

        case 2:
          return r = n.sent, n.next = 5, call(t, r);

        case 5:
        case "end":
          return n.stop();
      }
    }
  }, _marked$e, this);
}

var _marked$f = regenerator.mark(start),
    _marked2$a = regenerator.mark(_callee$6);

function start(e) {
  var t;
  return regenerator.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          return t = e.web3, r.next = 3, setContext({
            web3: t
          });

        case 3:
          return r.next = 5, all([_callee$2(), _callee$3(), _callee(), _callee$1(), _callee6(), _callee$5(), _callee$4(), logSaga(), sagaGenesisInit$1()]);

        case 5:
        case "end":
          return r.stop();
      }
    }
  }, _marked$f, this);
}

function _callee$6() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 2, fork(takeOnceAndRun, "WEB3_INITIALIZED", start);

        case 2:
          return e.next = 4, web3Initialize();

        case 4:
        case "end":
          return e.stop();
      }
    }
  }, _marked2$a, this);
}

var TransactionStateHandler = function () {
  function e() {
    classCallCheck(this, e);
  }

  return createClass(e, [{
    key: "handle",
    value: function value(e) {
      var t = this;
      return {
        onError: function onError(r) {
          return !t.hasError && e && e.error && (r(e.error), t.hasError = !0), t.handle(e);
        },
        onTxHash: function onTxHash(r) {
          return !t.hasTxHash && e && e.txHash && (r(e.txHash), t.hasTxHash = !0), t.handle(e);
        },
        onReceipt: function onReceipt(r) {
          return !t.hasReceipt && e && e.receipt && (r(e.receipt), t.hasReceipt = !0), t.handle(e);
        },
        onConfirmed: function onConfirmed(r) {
          return !t.hasConfirmed && e && e.confirmed && (r(), t.hasConfirmed = !0), t.handle(e);
        }
      };
    }
  }]), e;
}();

exports.nextId = nextId, exports.CallCountRegistry = CallCountRegistry, exports.ContractRegistry = ContractRegistry, exports.sagas = _callee$6, exports.TransactionStateHandler = TransactionStateHandler, exports.ContractRegistryProvider = ContractRegistryProvider, exports.withContractRegistry = withContractRegistry, exports.withSaga = withSaga, exports.withSend = withSend, exports.LogListener = LogListener, exports.contractByName = contractByName, exports.contractKeyByAddress = contractKeyByAddress, exports.cacheCallState = cacheCallState, exports.cacheCallValue = cacheCallValue, exports.cacheCallValueInt = cacheCallValueInt, exports.cacheCallValueBigNumber = cacheCallValueBigNumber, exports.hashCall = hashCall, exports.abiFactory = abiFactory, exports.createCall = createCall, exports.ABIHelper = ABIHelper, exports.addLogListener = addLogListener, exports.removeLogListener = removeLogListener, exports.logReducerFactory = logReducerFactory, exports.reducers = reducers, exports.start = start, exports.web3Send = web3Send, exports.addContract = addContract, exports.web3NetworkId = web3NetworkId, exports.takeOnceAndRun = takeOnceAndRun, exports.takeSequentially = takeSequentially, exports.runCall = runCall, exports.cacheCall = cacheCall, exports.cacheCallByName = cacheCallByName, exports.cacheCallByAddress = cacheCallByAddress, exports.callNoCache = callNoCache, exports.web3Call = web3Call;